import React, { useEffect, useState } from 'react'
import Select from '../../Components/Autocompelte/Select'
import CustomInput from '../../Components/Input/CustomInput'
import DatePicker from '../../Components/Input/DatePicker'
import stateCityData from '../../utils/StateAndCities.json'

const FleetRegister = ({ fleetRegister, setFleetRegister, errors }) => {
  const [selectedState, setSelectedState] = useState(null) // To store the selected state
  const [selectedCity, setSelectedCity] = useState(null) // To store the selected city
  const [cityOptions, setCityOptions] = useState([])
  const calculateMinDate = () => {
    const today = new Date()
    today.setFullYear(today.getFullYear() - 18)
    return today.toISOString().substr(0, 10)
  }
  const handleChange = (name, value) => {
    setFleetRegister((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleDateChange = (date) => {
    setFleetRegister((prevState) => ({
      ...prevState,
      birthDate: date,
    }))
  }

  useEffect(() => {
    // Reset city when state is changed
    if (selectedState) {
      setCityOptions(stateCityData[selectedState] || [])
      setSelectedCity(null) // Clear the selected city when state changes
    }
  }, [selectedState])

  return (
    <div className="mt-7">
      <div className="w-full text-start text-stone-500 text-sm md:text-base font-bold">
        Register Fleet
      </div>
      <div className="mt-2">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
          <div>
            <CustomInput
              placeholderValue={'First Name'}
              labelValue={'First Name'}
              required
              name="firstName"
              onChange={(value) => {
                const filteredValue = value.replace(/[^a-zA-Z]/g, '')
                handleChange('firstName', filteredValue)
              }}
              value={fleetRegister.firstName}
            />
            {errors.firstName && (
              <small className="text-red-500">{errors.firstName}</small>
            )}
          </div>
          <div>
            <CustomInput
              placeholderValue={'Last Name'}
              labelValue={'Last Name'}
              required
              name="lastName"
              onChange={(value) => {
                const filteredValue = value.replace(/[^a-zA-Z]/g, '')
                handleChange('lastName', filteredValue)
              }}
              value={fleetRegister.lastName}
            />
            {errors.lastName && (
              <small className="text-red-500">{errors.lastName}</small>
            )}
          </div>
          <div>
            <CustomInput
              formatMobileNumber
              placeholderValue={'Mobile Number'}
              type={'tel'}
              maxlength={'10'}
              labelValue={'Mobile Number'}
              required
              name="mobileNumber"
              onChange={(value) => handleChange('mobileNumber', value)}
              value={fleetRegister.mobileNumber}
            />
            {errors.mobileNumber && (
              <small className="text-red-500">{errors.mobileNumber}</small>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
          <div>
            <CustomInput
              formatMobileNumber
              placeholderValue={'Emergency Number'}
              labelValue={'Emergency Number'}
              type={'tel'}
              maxlength={'10'}
              name="emergencyNumber"
              onChange={(value) => handleChange('emergencyNumber', value)}
              value={fleetRegister.emergencyNumber}
            />
            {errors.emergencyNumber && (
              <small className="text-red-500">{errors.emergencyNumber}</small>
            )}
          </div>
          <div>
            <DatePicker
              labelValue="Birth Date"
              selected={fleetRegister.birthDate}
              onChange={handleDateChange}
              maxDate={calculateMinDate()}
            />
            {errors.birthDate && (
              <small className="text-red-500">{errors.birthDate}</small>
            )}
          </div>
          <div>
            <CustomInput
              placeholderValue={'Address'}
              labelValue={'Address'}
              required
              name="address"
              onChange={(value) => handleChange('address', value)}
              value={fleetRegister.address}
            />
            {errors.address && (
              <small className="text-red-500">{errors.address}</small>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
          <div>
            <Select
              selected={{
                label: selectedState,
                value: selectedState,
              }}
              labelValue={'Select State'}
              placeholderValue={'State'}
              options={Object.keys(stateCityData)
                .sort()
                .map((state) => ({
                  label: state,
                  value: state,
                }))}
              onSelect={(value) => {
                setSelectedState(value?.value) // Set the selected city
                setFleetRegister((prevState) => ({
                  ...prevState,
                  state: value?.value,
                  city: '',
                }))
              }}
            />

            {errors.state && (
              <small className="text-red-500">{errors.state}</small>
            )}
          </div>
          <div>
            {selectedState && (
              <>
                <Select
                  selected={{
                    label: selectedCity,
                    value: selectedCity,
                  }}
                  labelValue={'Select City'}
                  placeholderValue={'City'}
                  options={cityOptions.sort().map((city) => ({
                    label: city,
                    value: city,
                  }))}
                  onSelect={(value) => {
                    setSelectedCity(value?.value) // Set the selected city
                    setFleetRegister((prevState) => ({
                      ...prevState,
                      city: value?.value || '', // Update fleet register with the selected city
                    }))
                  }}
                />
                {errors.city && (
                  <small className="text-red-500">{errors.city}</small>
                )}
              </>
            )}
          </div>
          <div>
            <Select
              selected={{
                label: fleetRegister?.operationCity,
                value: fleetRegister?.operationCity,
              }}
              labelValue={'Select Operation City'}
              placeholderValue={'Operation City'}
              options={[
                { label: 'Pune', value: 'Pune' },
                { label: 'Mumbai', value: 'Mumbai' },
                { label: 'Bengaluru', value: 'Bengaluru' },
              ]}
              onSelect={(value) => {
                setFleetRegister((prevState) => ({
                  ...prevState,
                  operationCity: value?.value,
                }))
              }}
            />
            {errors.operationCity && (
              <small className="text-red-500">{errors.operationCity}</small>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
          <div>
            <CustomInput
              placeholderValue={'Email'}
              type={'email'}
              labelValue={'Email'}
              required
              name="email"
              onChange={(value) => {
                setFleetRegister((prevState) => ({
                  ...prevState,
                  email: value,
                }))
              }}
              value={fleetRegister?.email}
            />
            {errors.email && (
              <small className="text-red-500">{errors.email}</small>
            )}
          </div>
          <div>
            <CustomInput
              placeholderValue={'Password'}
              labelValue={'Password'}
              inputtype="password"
              required
              name="password"
              type="password"
              onChange={(value) => {
                setFleetRegister((prevState) => ({
                  ...prevState,
                  password: value,
                }))
              }}
              value={fleetRegister?.password}
            />
            {errors.password && (
              <small className="text-red-500">{errors.password}</small>
            )}
          </div>
        </div>
      </div>
      <style>
        {`
          .stsearch-box{
          display:flex;
          items
          }
          .stdropdown-menu{
          font-size:14px;
          width:100%;
          max-height:200px;
          overflow:scroll;
          background-color:white;
          position:absolute;
          z-index:100;
          }
        `}
      </style>
    </div>
  )
}

export default FleetRegister
